import { Banner } from '@buffer-mono/popcorn'
import useDismissBanner, {
  BannerTypes,
} from '../../../../common/hooks/useDismissBanner'

const LinkShorteningDisabledBanner = (): JSX.Element | null => {
  const { onDismissBanner, isActive } = useDismissBanner({
    banner: BannerTypes.linkShorteningDisabledBanner,
  })

  if (!isActive) {
    return null
  }

  return (
    <Banner variant="info" onDismiss={onDismissBanner}>
      <Banner.Text>
        Link shortening is now turned off by default. You can re-enable link
        shortening in your channel settings.
      </Banner.Text>
      <Banner.ActionLink
        target="_blank"
        href="https://support.buffer.com/article/620-shortening-and-unshortening-links"
      >
        Read more
      </Banner.ActionLink>
    </Banner>
  )
}

export default LinkShorteningDisabledBanner
